import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: '/', component: () => import('@/views/DashboardView.vue') },
    { path: '/dagboek', component: () => import('@/views/DagboekView.vue') },
    { path: '/snelboeking', component: () => import('@/views/SnelBoekingView.vue') },
    { path: '/bijdrage', component: () => import('@/views/BijdrageView.vue') },
    { path: '/overzichten', component: () => import('@/views/OverzichtenView.vue') },
    { path: '/instellingen', component: () => import('@/views/InstellingenView.vue') },
  ],
})

export default router
